export const COLUMN_WIDTH = 260;
export const COLLAPSED_COLUMN_WIDTH = 59;